<ng-container>
  <div #rtPlaceholders class="placeholders" padding-lr padding-tb-small>
    <div class="placeholders-heading" margin-right-small-x>
      {{ 'app.email_templates.placeholders' | translate }}
    </div>

    <rt-icon-help-with-dropdown
      [link]="'app.support_resources.placeholders' | translate"
      [infoText]="'app.email_templates.placeholders_description' | translate"
      (click)="$event.stopPropagation()"
      margin-right-small-x
    >
    </rt-icon-help-with-dropdown>

    <rt-placeholder-category-button
      *ngFor="let category of categories; trackBy: trackByCategoryName"
      [category]="category"
      [activeTarget]="activeTarget!"
      [placeholders]="filteredPlaceholders"
      (select)="this.trackInsertPlaceholder($event.id)"
      margin-right-small-x
    ></rt-placeholder-category-button>

    <rt-placeholder-button
      *ngFor="let placeholder of noCategoryPlaceholders; trackBy: trackByPlaceholderName"
      [insertPlaceholder]="placeholder.id"
      [insertPlaceholderTarget]="activeTarget!"
      [rtTooltip]="placeholder.interpolated ? placeholder.data.value : placeholder.data.description"
      [rtTooltipMaxWidth]="300"
      [rtTooltipHasTextAlignCenter]="true"
      [text]="placeholder.id"
      (click)="this.trackInsertPlaceholder(placeholder.id)"
      margin-right-small-x
    ></rt-placeholder-button>

    <div *ngIf="hasMore">
      <rt-button
        #dropdownTrigger="rtOverlayOrigin"
        (mousedown)="moreDropdownToggle($event)"
        [pressed]="moreDropdown.open"
        variant="plain"
        rt-overlay-origin
      >
        <rt-icon name="more-horiz" margin-right-small-x></rt-icon>
        <span>{{ 'app.common.more' | translate }}</span>
      </rt-button>

      <ng-template
        #moreDropdown="rtConnectedOverlay"
        [origin]="dropdownTrigger"
        [rtConnectedOverlayPosition]="['bottomleft']"
        (backdropClick)="moreDropdown.open = false"
        rt-connected-overlay
        hasBackdrop
      >
        <rt-placeholder-category-select-dropdown
          [header]="'app.email_templates.placeholder_categories_header' | translate"
          [placeholders]="filteredPlaceholders"
          [activeTarget]="activeTarget!"
          [customCategories]="moreCategories"
          [customNoCategoryPlaceholdersCollection]="moreNoCategoryPlaceholdersCollection"
          (select)="this.trackInsertPlaceholder($event.id)"
        ></rt-placeholder-category-select-dropdown>
      </ng-template>
    </div>
  </div>
</ng-container>
